import {Deserializable} from "../deserializable.model";

export class NotificationModal implements Deserializable{
 
    public UserId: string = '';
    public appType: string = '';    
    public date?: string = '';
    public endDate?:string='';
    public userGroup: string = '';   
    public message: string = '';
    public IsCompleted:string='';
    
    
    deserialize(input: any) {
      Object.assign(this, input);
      return this;
    }

}


export class AppType implements Deserializable
{
  AppType_ID!: string;
  APPTYPE!:string;

    deserialize(input: any) {
        Object.assign(this, input);
        return this;
      }
}

export class UserGroupList implements Deserializable
{
  ID!: string;
  UserGroup!:string;

    deserialize(input: any) {
        Object.assign(this, input);
        return this;
      }
}
